import { render, staticRenderFns } from "./BaseTableSearch.vue?vue&type=template&id=55ddfbd0&scoped=true&"
import script from "./BaseTableSearch.vue?vue&type=script&lang=js&"
export * from "./BaseTableSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ddfbd0",
  null
  
)

export default component.exports